// Test IDs for the Coachly marketplace & coach profile & reviews.

export const MARKETPLACE = {
  page: "marketplace-page",
  searchInput: "marketplace-search-input",
  specialtyFilter: (s) => `marketplace-filter-${s.toLowerCase().replace(/\s+/g, "-")}`,
  clearFilters: "marketplace-clear-filters",
  emptyState: "marketplace-empty-state",
  coachCard: (slug) => `coach-card-${slug}`,
  coachCardRating: (slug) => `coach-card-rating-${slug}`,
  coachCardCount: (slug) => `coach-card-count-${slug}`,
  coachCardCta: (slug) => `coach-card-cta-${slug}`,
  loading: "marketplace-loading",

  // New multi-filter UI
  filtersPanel: "marketplace-filters-panel",
  filtersMobileToggle: "marketplace-filters-mobile-toggle",
  filtersMobileClose: "marketplace-filters-mobile-close",
  sortSelect: "marketplace-sort-select",
  activeChipsRow: "marketplace-active-chips",
  activeChip: (key) => `marketplace-active-chip-${key}`,
  modeFilter: (m) => `marketplace-filter-mode-${m}`,
  cityFilter: (c) => `marketplace-filter-city-${c.toLowerCase().replace(/\s+/g, "-")}`,
  priceMin: "marketplace-filter-price-min",
  priceMax: "marketplace-filter-price-max",
  ratingFilter: (r) => `marketplace-filter-rating-${Number(r).toFixed(1).replace(".", "-")}`,
  levelFilter: (l) => `marketplace-filter-level-${l}`,
  languageFilter: (l) => `marketplace-filter-language-${l.toLowerCase()}`,
  availabilityFilter: (a) => `marketplace-filter-availability-${a}`,
  resultsCount: "marketplace-results-count",
};

export const COACH_PROFILE = {
  page: "coach-profile-page",
  header: "coach-profile-header",
  avgRating: "coach-profile-avg-rating",
  reviewCount: "coach-profile-review-count",
  bookCta: "coach-profile-book-cta",
  reviewsList: "coach-profile-reviews-list",
  reviewItem: (id) => `review-item-${id}`,
  reviewReply: (id) => `review-reply-${id}`,
  reviewReportBtn: (id) => `review-report-btn-${id}`,
  reviewReportedFlag: (id) => `review-reported-flag-${id}`,
  reviewReplyBtn: (id) => `review-reply-btn-${id}`,
  reviewReplyForm: (id) => `review-reply-form-${id}`,
  reviewReplyInput: (id) => `review-reply-input-${id}`,
  reviewReplyEmail: (id) => `review-reply-email-${id}`,
  reviewReplySubmit: (id) => `review-reply-submit-${id}`,

  // Review form
  reviewForm: "review-form",
  reviewFormOpen: "review-form-open",
  reviewFormEmail: "review-form-email",
  reviewFormName: "review-form-name",
  reviewFormComment: "review-form-comment",
  reviewFormSubmit: "review-form-submit",
  reviewFormSuccess: "review-form-success",
  reviewFormError: "review-form-error",
};
